import { Plus } from "lucide-react";
import { resolveMedia } from "@/utils/mediaResolver";

export default function CheckoutUpsellSection({ tc, fmt, suggestions, categories, onAddSuggestion, onRemoveSuggestion, onTrackUpsell }) {
  if (!suggestions.length) return null;
  return (
    <div className="rounded-xl border-2 border-dashed p-3 space-y-2"
      style={{ borderColor: `${tc.primary}40`, backgroundColor: `${tc.primary}05` }}
      data-testid="checkout-upsell">
      <p className="text-xs font-bold uppercase tracking-wider" style={{ color: tc.primary }}>Complete seu pedido</p>
      {suggestions.map(s => {
        const catName = categories.find(c => c.id === s.category_id)?.name || "";
        return (
          <button key={s.id}
            onClick={() => { onAddSuggestion(s); onRemoveSuggestion(s.id); onTrackUpsell("accepted", "checkout", s); }}
            className="w-full flex items-center gap-2.5 p-2 rounded-lg bg-white border border-gray-100 hover:border-current hover:shadow-sm transition-all group text-left"
            data-testid={`checkout-suggestion-${s.id}`}>
            {s.image_url ? (
              <img src={resolveMedia(s.image_url)} alt={s.name} className="w-11 h-11 rounded-lg object-cover shrink-0" />
            ) : (
              <div className="w-11 h-11 rounded-lg shrink-0 flex items-center justify-center text-lg" style={{ backgroundColor: `${tc.primary}10` }}>
                {catName?.toLowerCase().includes("bebida") ? "🍺" : catName?.toLowerCase().includes("postre") ? "🍰" : "🍽️"}
              </div>
            )}
            <div className="flex-1 min-w-0">
              <span className="font-semibold text-xs text-gray-900 block truncate">{s.name}</span>
              {catName && <span className="text-[10px] text-gray-400">{catName}</span>}
            </div>
            <div className="shrink-0 flex items-center gap-1.5">
              <span className="font-bold text-xs" style={{ color: tc.primary }}>+{fmt(s.price)}</span>
              <div className="w-7 h-7 rounded-full text-white flex items-center justify-center group-hover:scale-110 transition-transform" style={{ backgroundColor: tc.primary }}>
                <Plus className="w-3.5 h-3.5" />
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
